import React, { useState, useEffect } from 'react';
import HomePage from './HomePage';
// import Footer from '../component/Footer';
import UpcomingSkins from './UpcomingSkins';
import AboutUs from './AboutUs';
// import SkinDrops from './SkinDrops';
import Spotlight from './Spotlight';
import WhyChoose from './WhyChoose';
import UnlockDifferent from './UnlockDifferent';
import Faq from './Faq';

import FeatureLevelUp from "./FeaturePageSection/FeatureLevelUp";
import FeatureProcess from "./FeaturePageSection/FeatureProcess";

// Added props passed from App.jsx
function HomePageSection({ isLoggedIn, setIsLoggedIn, isLoginModalOpen, setLoginModalOpen, handleLogout }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Pass auth-related props to Header */}
      {/* <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      /> */}
      
      
      <HomePage 
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <UpcomingSkins />
      <AboutUs />
      {/* <SkinDrops /> */}
      <FeatureLevelUp />
      <Spotlight />
      <WhyChoose />
      <FeatureProcess />
      <UnlockDifferent />
      <Faq />
      {/* <Footer /> */}
    </>
  );
}

export default HomePageSection;